import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import DropBtn from "../modules/DropBtn";
import upload from "../../Assets/svg/upload-icon.svg";
import Button from "../modules/Button";
import StaticField from "../StaticField";
import close from "../../Assets/svg/close.svg";
import { useDispatch, useSelector } from "react-redux";
import { addFieldCount, addPersonalInfo } from "./redux/actions";
import verified from "../../Assets/svg/verified.svg";
import ErrorBoundary from "../modules/ERcomponent";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { modifyPage } from "../ApplicationForm/redux/actions";
import DocUpload from "../modules/DocUpload";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import StaticItem from "../modules/StaticItem";
import MultiSelect from "../modules/MultiSelect";
import TransitionAlerts from "../modules/Alerts";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { format, isDate, parse } from "date-fns";
// import { PDFDocument } from 'pdf-lib';
// import { Document, Page } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

function FieldSetTop(props) {
  // January 1, 1950
  const dispatch = useDispatch();
  const status = useSelector((state) => state.status.statusData);

  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const [err, showErr] = useState({ show: false, msg: "" });
  const [showContent, setShowContent] = useState({ mail: false, phone: false });
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [uploading, setUploading] = useState(false);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [date, setDate] = useState("");
  const [alert, setAlert] = useState(false);
  const calculateAge = (dateOfBirth) => {
    let age = "";
    if (dateOfBirth?.length !== 4) {
      const parts = dateOfBirth?.split("-");
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      const dob = new Date(year, month, day);

      const currentDate = new Date();

      age = currentDate.getFullYear() - dob.getFullYear();

      if (
        currentDate.getMonth() < dob.getMonth() ||
        (currentDate.getMonth() === dob.getMonth() &&
          currentDate.getDate() < dob.getDate())
      ) {
        age--;
      }
    } else {
      const currentYear = new Date().getFullYear();
      const birthYearNum = parseInt(dateOfBirth, 10);
      age = currentYear - birthYearNum;
    }

    return age;
  };

  const filterData = (type, value) => {
    if (type === "firstName") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (type === "pin") {
      value = value.replace(/\D/g, "");
    } else if (type === "mobile") {
      value = value.replace(/\D/g, "");
      // if (value.length > 9) {
      value = value.slice(0, 10);
      // }
    } else if (type === "BirthCertificate") {
      value = validateFileName(value);
      // } else if (type === "dob") {
      //   const enteredDate = new Date(value);
      //   const currentDate = new Date();
      //   const earliestDate = new Date("1950-01-01");
      //   if (
      //     enteredDate === currentDate ||
      //     enteredDate > currentDate ||
      //     enteredDate < earliestDate
      //   ) {
      //     alert(
      //       "Please select a date that is not before 1950 or not in the future."
      //     );
      //     value = "";
      //   }
      // }else if(type === 'dob'){
      //   setDate(value)
      //   value=formatDate(value)
    }
    return value;
  };
  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      props.showModal("File with double extensions is not allowed.");

      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const addData = (type, value) => {
    if (value) {
      value = filterData(type, value);
    }
    if (type === "photo" && value !== null) {
      const extension = value?.name.split(".").pop().toLowerCase();

      if (!["png", "jpg", "jpeg"].includes(extension)) {
        props.showModal(
          "Please upload a file with a PNG, JPG, or JPEG extension."
        );

        // alert("Please upload a file with a PNG, JPG, or JPEG extension.");
        showErr({
          show: true,
          msg: "Please upload a file with a PNG, JPG, or JPEG extension.",
        });
        value = null;
      } else if (value.size / 1024 / 1024 > 0.5) {
        showErr({
          show: true,
          msg: `${value.name} exceeds the maximum upload size limit.`,
        });
        props.showModal(`${value.name} exceeds the maximum upload size limit.`);

        value = null;
        // showErr(true);
      } else {
        showErr({
          show: false,
          msg: ``,
        });
      }
      value = validateFileName(value);

      // setTimeout(() => showErr({ show: false, msg: "" }), 5000);
      // } else if (type === "dob") {
      //  console.log('in year', value)
    } else if (type === "disability") {
      let newValue = "";
      for (let i in value) {
        if (!personalInfo?.disability?.includes(value[i])) {
          newValue = value[i];
        }
      }
      if (newValue === "No") {
        value = ["No"];
      } else if (personalInfo?.disability?.includes("No")) {
        value = value.filter((item) => item !== "No");
      }
    }
    if (type === "dob") {
      if (value !== "") {
        dispatch(addPersonalInfo({ type: type, value: value }));
      }
    } else {
      dispatch(addPersonalInfo({ type: type, value: value }));
    }
    dispatch(modifyPage("Yes"));
  };

  const uploadFunction = async (data) => {
    try {
      const result = await api.uploadDocument(
        "application",
        tokenData?.applicationData.id,
        tokenData?.token,
        data
      );
      if (result?.statusCode == 200) {
        props.showModal("Your Document has been uploaded successfully!");

        // alert("Your Document has been uploaded successfully!");
      }

      return result;
    } catch (error) {
      alert("Sorry! Something went wrong, Please try again.", error);

      setUploading(false);
    }
  };

  const uploadDoc = async (type, e) => {
    const formData = new FormData();
    formData.append("file", e);
    formData.append("name", e.name);
    formData.append("size", e.size);
    formData.append("documentType", type);
    formData.append("fileType", e.type.split("/")[1]);
    let id = "";
    if (type === "profilePicture" && docs?.profilePicture) {
      id = docs?.profilePicture.id;
    } else if (type === "BirthCertificate" && docs?.BirthCertificate) {
      id = docs?.BirthCertificate.id;
    }
    if (id) {
      formData.append("id", id);
    }
    try {
      const result = await uploadFunction(formData);
      if (result?.statusCode == 200) {
        props.showModal("Your Document has been uploaded successfully!");

        // alert("Your Document has been uploaded successfully!");
      }
      // addData(type, '')
      return result;
    } catch (err) {
      console.log("error", err.data);
    }
  };

  const getDoc = async () => {
    try {
      const docs2 = await api.getDocuments(
        "application",
        tokenData.applicationData.id,
        tokenData.token
      );
      return docs2;
    } catch (err) {
      console.log("error", err.data);
    }
  };

  const getValidDate = (date) => {
    if (date?.split("-")[0]?.length > 2) {
      date = date?.split("-")?.reverse()?.join("-");
    } else if (!date?.split("-")[1]) {
      date = `${personalInfo?.dob}-01-01`;
    }
    return date;
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    const parsedDate = parse(value, "yyyy-MM-dd", new Date());
    const formattedDate = format(parsedDate, "dd-MM-yyyy");
    addData("dob", formattedDate);
  };

  const formatDateForInput = (date) => {
    if (!date) return "";
    const parsedDate = parse(date, "dd-MM-yyyy", new Date());
    return format(parsedDate, "yyyy-MM-dd");
  };

  function transformDate(dateStr) {
    // Split the date string into components
    dateStr = getValidDate(dateStr);
    const [day, month, year] = dateStr.split("-").map(Number);
    // Create a new Date object
    const date = new Date(year, month - 1, day);

    // Format the date to the required string format
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "long",
      timeZone: "Asia/Kolkata",
    };
    // console.log(
    //   "display normal",
    //   date,
    //   date.toLocaleString("en-US", options).replace(",", "")
    // );
    return date;
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    // console.log()
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    // console.log("dateString",day, month, year)
    return `${day}-${month}-${year}`;
    // return day
  }
  const checkFormat = (file) => {
    const extension = file?.name.split(".").pop().toLowerCase();

    if (!["png", "jpg", "jpeg"].includes(extension)) {
      props.showModal(
        "Please upload a file with a PNG, JPG, or JPEG extension."
      );

      // alert("Please upload a file with a PNG, JPG, or JPEG extension.");
      // showErr({
      //   show: true,
      //   msg: "Please upload a file with a PNG, JPG, or JPEG extension.",
      // });
      file = null;
    } else if (file.size / 1024 / 1024 > 0.5) {
      // showErr({
      //   show: true,
      //   msg: `${file.name} exceeds the maximum upload size limit.`,
      // });
      props.showModal(`${file.name} exceeds the maximum upload size limit.`);

      file = null;
      // showErr(true);
    }
    return file;
  };
  const delDoc = async (type, e) => {
    // addData(type, e);
    // if (personalInfo[type]) {
    if (type === "profilePicture") {
      e = checkFormat(e);
    }
    if (e) {
      console.log("type", type);
      try {
        setUploading(true);
        const formData = new FormData();
        let file;
        if (docs[type]) {
          file = docs[type];
        }
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", type);
        formData.append("fileType", e.type.split("/")[1]);
        if (file) {
          formData.append("id", file.id);
        }
        // try {
        const result = await uploadFunction(formData);
        addData(type, "");
        if (result?.statusCode == 200) {
          props.showModal("Your Document has been uploaded successfully!");
          // alert("Your Document has been uploaded successfully!");
          // setTimeout(() => setAlert(false), 3000);
        }
        const docs2 = await getDoc();
        dispatch(addTokenInfo(["docs", docs2.data]));
        setUploading(false);
        addData("photo", "");
        // if (docs2[type]) {
        //   addData("photo", "data");
        // }
      } catch (error) {
        // alert("Sorry! Something went wrong, Please try again.");

        console.error("Error uploading document:", error);
        const docs2 = await getDoc();
        // console.log("docs2", docs2);
        dispatch(addTokenInfo(["docs", docs2.data]));
        setUploading(false);
      }
    }
  };
  const handleUpload = async (type, e) => {
    e = validateFileName(e);
    if (type === "profilePicture") {
      e = checkFormat(e);
    }
    if (e) {
      try {
        setUploading(true);
        const uploadResult = await uploadDoc(type, e);
        // console.log("upload result", uploadResult);
        if (uploadResult?.statusCode == 200) {
          let resData=''
          if(type === "profilePicture"){
             resData="Your photo has been uploaded successfully!"

          }else{
            resData="Your Document has been uploaded successfully!"

          }
          props.showModal(resData);

          // alert("Your Document has been uploaded successfully!");
          // setAlert(true);
          // setTimeout(() => setAlert(false), 3000);
        }
        addData(type, "");
        const docs2 = await getDoc();
        dispatch(addTokenInfo(["docs", docs2.data]));
        setUploading(false);
        addData("photo", null);
        if (docs2.data.profilePicture) {
          addData("photo", "data");
        }
      } catch (error) {
        // alert("Sorry! Something went wrong, Please try again.");
        console.error("Error uploading document:", error);
        const docs2 = await getDoc();
        dispatch(addTokenInfo(["docs", docs2.data]));
        setUploading(false);
      }
    }
  };
  function isValidDate(dateString) {
    let str = dateString;
    const date = new Date(personalInfo?.dob);
    let isValid = date instanceof Date && !isNaN(date);
    //   if(isValid){
    //    str=`${personalInfo?.dob.split("-")[0]}-${str?.split("-")[1]}-${str?.split("-")[2]}`
    //  }
    setDate(str);
  }
  useEffect(() => {
    dispatch(addTokenInfo(["personalData", personalInfo]));
    let errList = [];
    let items = ["firstName", "photo", "experience"];
    for (let i in items) {
      if (!personalInfo[items[i]]) {
        errList = [...errList, items[i]];
      }
    }
    const date = new Date(personalInfo?.dob);
    let isValid = date instanceof Date && !isNaN(date);
    if (isValid) {
      let value = transformDate(personalInfo.dob);
      setDate(personalInfo.dob);
    }
    dispatch(addFieldCount({ field1: errList?.length }));
  }, [personalInfo]);

  useEffect(() => {
    if (personalInfo?.email !== "") {
      setShowContent((prevState) => {
        // Returning a new object with the updated count
        return { ...prevState, mail: true };
      });
    }
    if (personalInfo?.mobile !== "") {
      setShowContent((prevState) => {
        // Returning a new object with the updated count
        return { ...prevState, phone: true };
      });
    }

    // let value = transformDate("2000-01-1991");
    //   console.log(value);
    //   setDate(value);
    let isValid =
      personalInfo?.dob instanceof Date && !isNaN(personalInfo?.dob);

    if (isValid) {
      let value = transformDate(personalInfo.dob);
      setDate(value);
    }
    let errList = [];
    // let count=0
    let items = ["firstName", "photo", "experience"];
    for (let i in items) {
      if (!personalInfo[items[i]]) {
        errList = [...errList, items[i]];
        // count=errList.length
      }
    }

    dispatch(addFieldCount({ field1: errList?.length }));
  }, []);
  useEffect(() => {
    let newDate = date;
    const today1 = new Date();
    const givenDate = new Date(newDate); // Replace with the actual date to be checked
    const isFuture = givenDate > today1;
    // if (!isValidDateFormat(newDate)) {
    //   newDate = formatDate(newDate);
    //   console.log("before split", newDate);
    // }
    let year2 = Number(newDate?.split("-")[0]);
    if (year2 > 1000 && year2 < 1950) {
      newDate = "";
      props.showModal("Please select a date after 1950");
    } else if (isFuture) {
      // value = "";
      newDate = "";

      props.showModal("Please select a date before today");
      // alert("Please select a date before today");
    }
    setDate(newDate);
    addData("dob", newDate);
  }, [date]);
  // console.log("in personal photo", personalInfo, date);
  return (
    <div className="field-set set-one set-top">
      <div className="set-left set">
        <div className="field">
          <div className="set-title">Basic Details</div>
          <StaticField
            showTick={true}
            title={"Full Name"}
            value={personalInfo?.firstName}
          />
          {/* <div className=""> */}

          {/* <Input
            placeholder={"Full Name"}
            value={personalInfo?.firstName}
            onChange={(e) => addData("firstName", e)}
          /> */}

          <StaticField
            showTick={true}
            title={"Gender"}
            value={personalInfo?.gender}
          />
          {/* <div className="custom-input">
              <div className="custom-input-div">
                DOB
                <input
                  type="date"
                  id="date-picker"
                  value={formatDateForInput(personalInfo.dob)}
                  format="dd-MM-yyyy"
                  onChange={handleDateChange}
                  min="1950-01-01"
                />
              </div>
            </div> */}

          {/* <div className="date-div">
            <ErrorBoundary>
            <StaticField
              // showTick={true}
              title={"Date of Birth"}
              // value={personalInfo?.firstName}
            >
            <DatePicker
                id="datePicker"
                className="static-div"
                selected={date}
                onChange={(e) => addData("dob", e)}
                minDate={minDate} // Restrict the date before 1950
                dateFormat="dd-MM-yyyy"
              />

            </StaticField>
            </ErrorBoundary>
            {date && (
              <div className="age-text sub-option-text">
                {calculateAge(getValidDate(formatDate(date)))} years old
                <img src={verified} alt="verified" />
              </div>
            )}
          </div>
          <div className="set-sub-title">
            Please ensure your Date of Birth is correct
          </div> */}
          {/* <div className="date-div">
           
           
          {/* <DatePicker */}
          <div className="custom-input">
            <div className="custom-input-age">
              {tokenData?.defaultDob ? (
                <StaticField
                  showTick={true}
                  title={"Dob"}
                  value={personalInfo?.dob.split("-").reverse().join("-")}
                />
              ) : (
                <div className="custom-input-div">
                  Date of Birth
                  <input
                    min={"1950-01-01"}
                    // max={"2024-12-31"}
                    placeholder={"Date of birth"}
                    // disabled={props.item.firstName === "" || props.item.dob === ""}
                    // id="panNumber"
                    value={date}
                    // value={personalInfo?.dob}
                    // onKeyDown={(e) => props.type === "date" && e.preventDefault()}
                    onChange={(e) => isValidDate(e.target.value)}
                    type="date"
                  />
                </div>
              )}
              {date && (
                <div className="age-text sub-option-text">
                  {calculateAge(getValidDate(formatDate(date)))} years old
                  <img src={verified} alt="verified" />
                </div>
              )}
            </div>
            {status?.personalList?.rest?.includes("dob") && (
              <p style={{ color: "#f64c4c" }} className="set-sub-title">
                Required
              </p>
            )}
            <div className="set-sub-title">
              Please ensure your Date of Birth is correct
            </div>
          </div>

          <StaticField
            showTick={true}
            title={"Mobile Number"}
            mask={true}
            value={personalInfo?.mobile}
          />
          {/* ) : (
            <Input
              placeholder={"Mobile Number"}
              value={personalInfo?.mobile}
              id={"mobile"}
              onChange={(e) => addData("mobile", e)}
            />
          )} */}
          {/* {showContent?.mail ? ( */}
          <StaticField
            showTick={true}
            title={"Email Id"}
            mask={true}
            value={personalInfo?.email}
          />
          {/* ) : (
            <Input
              placeholder={"Email Id"}
              value={personalInfo?.email}
              onChange={(e) => addData("email", e)}
            />
          )} */}
          {/* <div className="field  right-btm"> */}
          <div className="multi-select income-field-set">
            <MultiSelect
              title={"Are you a person with a disability (Optional)"}
              type={"disability"}
              list={personalInfo?.disability}
              names={[
                "No",
                "Blindness",
                "Low-Vision",
                "Leprosy Cured Persons",
                "Hearing Impairment (deaf and hard of hearing)",
                "Locomotor Disability",
                "Dwarfism",
                "Intellectual Disability",
                "Mental Illness",
                "Autism Spectrum Disorder",
                "Cerebral Palsy",
                "Muscular Dystrophy",
                "Chronic Neurological Conditions",
                "Specific Learning Disabilities (Dyslexia)",
                "Multiple Sclerosis",
                "Speech and Language Disability",
                "Thalassemia",
                "Hemophilia",
                "Sickle Cell Disease",
                "Multiple Disabilities including Deaf-Blindness",
                "Acid Attack Victim",
                "Parkinson's Disease",
              ]}
              onChange={(e) => addData("disability", e)}
            />
          </div>
          {/* <div className="field  right-btm"> */}
          <DropBtn
            title={"Are you an orphan? (Optional)"}
            value={personalInfo?.orphan || ""}
            list={["Yes", "No"]}
            onChange={(e) => addData("orphan", e)}
          />
          {/* </div> */}
        </div>{" "}
      </div>
      <div className="set-right set">
        {" "}
        <div className="field right-top">
          <div className="set-title">Photograph</div>
          <div className="set-sub-title">
            Upload a recent, clear, passport size photograph
          </div>
          {(docs && docs?.profilePicture) || personalInfo?.photo?.name ? (
            <ErrorBoundary>
              <div className="upload-image ">
                <img
                  className="image"
                  src={
                    docs?.profilePicture?.fileBlob
                      ? "data:image/" +
                        docs?.profilePicture.fileType +
                        ";base64," +
                        docs?.profilePicture.fileBlob
                      : URL.createObjectURL(personalInfo?.photo)
                  }
                  alt="Preview"
                  style={{ maxWidth: "100%", height: "100%" }}
                />
                <div className="close-icon">
                  {/* {docs?.profilePicture?.name &&  */}
                  <Input
                    type="file"
                    accept=".pdf"
                    onChange={(e) => delDoc("profilePicture", e)}
                  />
                  {/* } */}
                  <img src={close} alt="close" />
                </div>
              </div>
            </ErrorBoundary>
          ) : (
            <div className="upload-div">
              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  handleUpload(`profilePicture`, e.target.files[0])
                }
              />
              <div className="icon">
                <img src={upload} alt="upload" />
                <div className="upload-text">Upload Photo</div>
              </div>
              <div className="center-text">
                <div className="text-one">Drag & drop or upload</div>
                <div className="text-two">
                  Max: <span>500KB</span>
                </div>
              </div>
              <div className="text-one">Supported formats: PNG, JPG,JPEG</div>
            </div>
          )}
          {/* {personalInfo?.photo?.name && !docs?.profilePicture && (
            <Button
              onClickHandler={() => handleUpload(`profilePicture`)}
              value={uploading ? "Uploading..." : "Upload"}
              type={"contained"}
              disabled={uploading}
            />
          )} */}
          {status?.personalList?.rest?.includes("photo") && (
            <p className="set-sub-title">Required</p>
          )}
        </div>{" "}
        <div
          className={`field-row upload field ${
            docs && docs?.BirthCertificate?.name && "doc-col"
          }`}
        >
          {docs?.BirthCertificate ? (
            <div className="doc-item">
              <StaticItem
                onDelete={(e) => delDoc("BirthCertificate", e)}
                type={"doc"}
                isEditable={true}
                doc={docs?.BirthCertificate}
                title={"Birth Certificate"}
                docUrl={docs?.BirthCertificate?.documentUrl}
                value={docs?.BirthCertificate?.name}
                size={Math.floor(docs?.BirthCertificate?.size / 1024)}
              />
            </div>
          ) : (
            <div className="field file-upload-container">
              <DocUpload
                title={"Birth Certificate"}
                noTooltip={true}
                value={
                  personalInfo?.BirthCertificate?.name
                    ? personalInfo?.BirthCertificate
                    : ""
                }
                placeholder={"Upload Birth Certificate"}
                onChange={(e) => handleUpload("BirthCertificate", e)}
              />
            </div>
          )}
          {status?.personalList?.rest?.includes("BirthCertificate") && (
            <p className="set-sub-title">Required</p>
          )}
        </div>
        <div className="field  right-btm">
          <div className="set-title">Work Experience</div>

          <DropBtn
            title={"How many months of work experience?"}
            value={personalInfo?.experience || ""}
            list={[
              "No work Experience",
              "Less than 6 months",
              "7 to 15 months",
              "16 to 25 months",
              "26 to 35 months",
              "More than 35 months",
            ]}
            onChange={(e) => addData("experience", e)}
          />
        </div>
        {status?.personalList?.rest?.includes("experience") && (
          <p style={{ color: "#f64c4c" }} className="set-sub-title">
            Required
          </p>
        )}
      </div>
      {alertType.msg && (
        <TransitionAlerts isAlert={alert} message={alertType.msg} />
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default FieldSetTop;
